import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import { ToggleSound } from '~/components/ui/ToggleSound';

const StyledContainer = styled.div`
	position: absolute;
	top: 80px;
	padding: 0 80px;
	width: 100%;
	display: grid;
	grid-template-columns: 300px 1fr 300px;
	justify-content: space-between;
	align-items: start;
`;

const StyledUser = styled.div`
	justify-self: start;
	display: flex;
	align-items: center;
	gap: 10px;
	height: 40px;
	padding: 0 10px;
	background: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 700;
		font-size: 18px;
		color: #ffffff;
	}
`;

const StyledRightSide = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 20px;
`;

const StyledBalance = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 10px;
	height: 40px;
	padding: 0 10px;
	background: rgba(17, 19, 20, 0.98);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	overflow: hidden;

	${Text} {
		font-weight: 700;
		font-size: 18px;
		color: #ffffff;
	}
`;

const StyledToggleSound = styled(ToggleSound)`
	position: static;

	&[data-muted] .img-icon {
		opacity: 0.25;
	}
`;

export {
	StyledBalance,
	StyledContainer,
	StyledRightSide,
	StyledToggleSound,
	StyledUser,
};
